const getAssetUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const appUrl = process.env.CARVANA_APP_PUBLIC_URL!;
  const prefix = appUrl.includes('localhost') ? appUrl : `${appUrl}/_next/static/public`;

  return `${prefix}${normalizedPath}`;
};

export default getAssetUrl;
